module.exports = __webpack_public_path__ + "LEXUS-logo.png";